<template>
    <div class="cents">
        <van-nav-bar
            :title="$t('lykm')"
            left-arrow
            safe-area-inset-top
            style="background-color: #1ABC9C;"
            @click-left="goto"
            />
        <div  class="contes">
            
            <div style="display: flex;
    justify-content: space-between;">
                <input type="text" class="inputs" v-model="keyword">
                <button @click="sheach">{{$t('ss')}}</button>
                <van-button @click="Blesdom">{{$t('lya')}}</van-button>
            </div>

            
            
            <!-- <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('mygd')"
                @load="onLoad"
            > -->
                <div class="shebeq">
                    
                    <div v-for="item in eqList" class="shey" :key="item.id" @click="hanlOpenble(item)">
                        <div :class="item.is_online? 'yuan colorsold ': 'yuan colors' ">
                            <van-icon name="wap-home" />
                        </div>
                        <p style="margin-top:4px">{{$t('wz')}}：{{item.name}}</p>
                        <p>{{$t('lym')}}：awork{{item.serial_number}}</p>
                    </div>
                </div>
            <!-- </van-list> -->
				
        </div>
		<!-- 分页 -->
		<div class="data-load-more" v-if="deviceCount>10||Math.ceil(deviceCount/10)>1">
			<div @click="goTop">{{this.$t('syy')}}</div>
			<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
			<div class="pageSizeBox">
				<div v-for="(item,index) in pageSizeList" :key="item" style="width: 25px;" @click="handlePageSize(item)" :class="[page_index==item?'pageSizeItemState':'']">
					{{item>pageSize?'':item}}
				</div>
			</div>
			<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
			<div @click="goBottom">{{this.$t('xyy')}}</div>
		</div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import {ble_config,readBluetooth,startOpenDoor,openDoorInfo} from '@/ble/dooroperator.js'

var current_device = null;
export default {
    data(){
        return{
            loading:false,
            finished: false,
            UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
            keyword:'',
            eqList:[],
            page_index:1,
            count:null,


            service_uuid:"",
            properties:null,
            //  蓝牙
            btconnecting : false,
            device_found:0,
            temp : [],
            device_serial:'',
            device_mac:'',
            device_key:'',
			deviceCount:0, // 接口返回设备数量
			pageSize:0, // 设备页数
			pageSizeList:[1,2,3,4,5], // 页码
        }
    },
    mounted(){
        this.geteqlist()
    },
    methods:{
        
        Blesdom(){
            // console.log(ble_config)
            // return false
            current_device = null;
            console.log('Requesting any Bluetooth Device...');
            navigator.bluetooth.requestDevice({
                    // acceptAllDevices: true,
                    filters: [ 
                    	{ namePrefix: 'awork' } 
                    ],
                    optionalServices: [
                        '49535343-fe7d-4ae5-8fa9-9fafd205e455',
                        "alert_notification",
                        "automation_io",
                        "battery_service",
                        "blood_pressure",
                        "body_composition",
                        "bond_management",
                        "continuous_glucose_monitoring",
                        "current_time",
                        "cycling_power",
                        "cycling_power",
                        "cycling_speed_and_cadence",
                        "device_information",
                        "environmental_sensing",
                        "generic_access",
                        "generic_attribute",
                        "glucose",
                        "health_thermometer",
                        "heart_rate",
                        "human_interface_device",
                        "immediate_alert",
                        "indoor_positioning",
                        "internet_protocol_support",
                        "link_loss",
                        "location_and_navigation",
                        "next_dst_change",
                        "phone_alert_status",
                        "pulse_oximeter",
                        "reference_time_update",
                        "running_speed_and_cadence",
                        "scan_parameters",
                        "tx_power",
                        "user_data",
                        "weight_scale"
                    ]
                })
                .then(device => {
                    current_device = device;
                    console.log(current_device)
                    // $("#device").text(device.name);
                    // $("#openBtn").prop("disabled", false);
                })
                .catch(error => {
                    this.addMessage(error);
                });
        },
        // 蓝牙开门
        hanlOpenble(item){
            if(current_device){
                this.addMessage('Connecting to GATT Server...');
                current_device.gatt.connect().then(server => {
                   this.addMessage('Getting Services...');
                    return server.getPrimaryServices();
                }).then(services => {
                    console.log(`999`,services)
              
                    return this.overrideServices(services,item.btkey);
                }).catch(error => {
                    Toast.fail(this.$t('kmsb'))
                    this.addMessage(error);
                });
            }else{
                Toast.fail(this.$t('qxdkly'))
            }
        },
        addMessage(str){
            console.log(str);
           
        },
        isMobile() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (
                bIsIpad ||
                bIsIphoneOs ||
                bIsMidp ||
                bIsUc7 ||
                bIsUc ||
                bIsAndroid ||
                bIsCE ||
                bIsWM
            ) {
                return true;
            } else {
                return false;
            }
        },

        openDoor(characteristic,btkey){
            let _this = this
            startOpenDoor({
                device: characteristic,
                key: btkey,
                isValid: true,
                cardId: '123456',
                onComplete: function(res){
                    current_device.gatt.disconnect();
                    // $("#openStatus").text(res?"开门成功":"开门失败");
                    if(res){
                        Toast.success(_this.$t('kmcg'))
                    }else{
                        Toast.fail(_this.$t('kmsb'))
                    }
                },
                addlog:this.addMessage
            });
        },

        overrideServices(services,btkey) {
                this.addMessage('Getting Characteristics...');
                let queue = Promise.resolve();
                services.forEach(service => {
                    this.addMessage('> Service: ' + service.uuid);
                    if(service.uuid.toUpperCase() == ble_config.UUID_SERVICE){
                        queue = queue.then(_ => service.getCharacteristics().then(characteristics => {
                            console.log(_,characteristics)
                            let properties;
                            let uuid;
                            characteristics.forEach(characteristic => {
                                this.addMessage('> characteristic: ' + characteristic.uuid);
                                uuid = characteristic.uuid.toUpperCase();
                                if(uuid == ble_config.UUID_NOTIFY){
                                    console.log(111)
                                    properties = this.getSupportedProperties(characteristic)
                                    if (properties.indexOf("NOTIFY") != -1) {
                                        characteristic.startNotifications();
                                        characteristic.addEventListener('characteristicvaluechanged', function(event) {
                                            const value = event.target.value;
                                            readBluetooth(value.buffer);
                                        });
                                    }
                                }
                                else if(uuid == ble_config.UUID_WRITE){
                                    console.log(222)
                                    let _this = this
                                    if(this.isMobile()){
                                        setTimeout(function(){								
                                            _this.openDoor(characteristic,btkey);
                                        }, 300);
                                    }else{
                                        _this.openDoor(characteristic,btkey);
                                    }
                                }
                            });
                        }));
                    }
                });

                return queue;
            },

        getSupportedProperties(characteristic) {
            let supportedProperties = [];
            for (const p in characteristic.properties) {
                if (characteristic.properties[p] === true) {
                    supportedProperties.push(p.toUpperCase());
                }
            }
            return '[' + supportedProperties.join(', ') + ']';
        },





		




        // 返回
        goto(){
            this.$router.go(-1)
        },
        

        // 搜索
        sheach(){
            this.geteqlist()
        },
		// 页码点击
		handlePageSize(index){
			console.log(index,this.pageSize);
			console.log(this.page_index);
			 if(index>this.pageSize){
				return
			};
			this.page_index = index;
			this.geteqlist()
		},
		// 上个页码
		pageTop(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item-=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr;
		},
		// 下页码
		pageBottom(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item+=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr
		},
		// 上一页
		goTop(){
			if(this.deviceCount==0){
			  return
			};
			if(this.page_index==1){
			  this.$message.info(this.$t('ysdyy'))
			  return
			};
			this.page_index--;
			if(this.page_index<this.pageSizeList[0]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item-=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[4]
			}
			this.geteqlist()
		},
		// 下一页
		goBottom(){
			if(this.deviceCount==0){
			  return
			}
			if(this.page_index==this.pageSize){
			  this.$message.info(this.$t('mygd'))
			  return
			}
			this.page_index++;
			if(this.page_index>this.pageSizeList[4]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item+=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[0]
			}
			this.geteqlist()
		},
        // 获取设备
        onLoad() {
            this.page_index++;
            this.geteqlist()
        },
        geteqlist(){
            let data ={
                method:"co.wx.bluetooth.device.list",
                user_id:this.UserInfo.user_id,
                page_index:this.page_index,
                page_size:10,
                keyword:this.keyword
            }
            this.$serve(data).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.eqList =res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/10);
                    this.loading = false;
                    this.count = res.data.count
                    if (res.data.data == [] || this.count.length === 0) {
                        // 加载结束
                        this.finished = true;
                        return;
                    }
                    // this.eqList = this.eqList.concat(res.data.data)
                    
                    if (this.eqList.length >= this.count) {
                        this.finished = true;
                    }
                }
            })
        }
    }
}
</script>
<style scoped>
	.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
.contes{
    width: 85%;
    margin: 0 auto;
    margin-top: 20px;
}
.contes .inputs{
    width: 120px;
    height: 32px;
    padding-top: 4px;
    border: none;
    border-radius: 3px;
    border: 1px solid #ccc;
}
.contes button{
    height: 33px;
    margin-left: 20px;
    border: none;
    background-color: #1ABC9C;
    padding: 0 15px;
    font-size: 14px;
    color: #fff;
    border-radius: 3px;
}
.shebeq{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.shebeq p{
    text-align: left;
    margin: 0;
    font-size: 12px;
}
/* .shebeq::after{
    content: " ";
    width: 75px;
    height: 75px;
} */
.colors{
    color: #ccc;
    border: 1px solid #ccc;
}
.colorsold{
    color: #1ABC9C;
    border: 1px solid #1ABC9C;
}
.yuan{
    width: 75px;
    height: 75px;
    border: 1px solid #ccc;
    border-radius: 50%;
    text-align: center;
    font-size: 40px;
    line-height: 85px;
}
.shey{
    text-align: center;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
</style>